import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { GoCardlessPage } from './gocardless.page';

const routes: Routes = [
  {
    path: '',
    component: GoCardlessPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GoCardlessPageRoutingModule {}
